module.exports = __webpack_public_path__ + "img/img1.c1d00216.jpg";